const AgentType = {
  RealEstate: 'RealEstate',
  MortgageBroker: 'MortgageBroker',
} as const;

type AgentType = (typeof AgentType)[keyof typeof AgentType];

export { AgentType };
